var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA0B1",
    fillRule: "evenodd",
    d: "M13 13c0 1.306-.835 2.417-2 2.83V17c0 .552-.444 1-1 1-.552 0-1-.445-1-1v-1.17c-1.165-.413-2-1.524-2-2.83s.835-2.417 2-2.83V1c0-.552.444-1 1-1 .552 0 1 .445 1 1v9.17c1.165.413 2 1.524 2 2.83zm7-6c0 1.306-.835 2.417-2 2.83V17c0 .552-.444 1-1 1-.552 0-1-.445-1-1V9.83c-1.165-.413-2-1.524-2-2.83s.835-2.417 2-2.83V1c0-.552.444-1 1-1 .552 0 1 .445 1 1v3.17c1.165.413 2 1.524 2 2.83zM6 5c0 1.306-.835 2.417-2 2.83V17c0 .552-.444 1-1 1-.552 0-1-.445-1-1V7.83C.835 7.416 0 6.305 0 5s.835-2.417 2-2.83V1c0-.552.444-1 1-1 .552 0 1 .445 1 1v1.17C5.165 2.584 6 3.695 6 5zM3 6c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm7 8c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm7-6c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.bc6161feeebd9a70cfcdfb2edbd13ec5.svg";
export { ForwardRef as ReactComponent };